import { createRoot } from 'react-dom/client';
import App, { preloadRoute } from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import { installGlobalErrorHandler } from './lib/errorReporting';
import '../design/tokens.css';
import './index.css';

installGlobalErrorHandler();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root was not found.');
}

const root = createRoot(container);
const render = () =>
  root.render(
    <ThemeProvider>
      <App />
    </ThemeProvider>
  );

// Load the initial route's chunk before mounting, so the prerendered #root
// markup stays on screen until React replaces it with the same page in one
// commit — instead of the Suspense spinner in between. A failed preload still
// renders, falling back to the normal lazy/Suspense path.
const initialRoute = preloadRoute(window.location.pathname);
if (initialRoute) initialRoute.then(render, render);
else render();
